import { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { getSupabaseClient } from "../providers/supabase/supabase";

// Sprint 10.x — Pulse produit (7j) sur /today dev.
// Source : edge function posthog_pulse → HogQL agrégat events fabrik-1.

type PulseKpi = { key: string; label: string; value: number };
type PulseResponse = { configured: boolean; days: number; kpis: PulseKpi[] };

export function PulseCard() {
  const [state, setState] = useState<{
    loading: boolean;
    error: string | null;
    data: PulseResponse | null;
  }>({ loading: true, error: null, data: null });

  useEffect(() => {
    (async () => {
      const { data, error } = await getSupabaseClient().functions.invoke(
        "posthog_pulse",
        { body: { days: 7 } },
      );
      if (error) {
        setState({
          loading: false,
          error: error.message ?? "Erreur PostHog",
          data: null,
        });
        return;
      }
      setState({ loading: false, error: null, data: data as PulseResponse });
    })();
  }, []);

  return (
    <Card>
      <CardContent className="p-0">
        <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
          <BarChart3 className="size-4 text-fabrik-text-3" />
          <h2 className="text-[14px] font-semibold text-foreground">
            Pulse produit
          </h2>
          <span className="ml-auto text-[11.5px] text-fabrik-text-3">
            7 derniers jours
          </span>
        </div>
        {state.loading ? (
          <div className="p-4">
            <Skeleton className="h-16 w-full" />
          </div>
        ) : state.error ? (
          <p className="text-[12.5px] text-fabrik-red px-4 py-3">
            {state.error}
          </p>
        ) : !state.data?.configured ? (
          <p className="text-[12.5px] text-fabrik-text-3 px-4 py-3">
            PostHog non configuré (Paramètres → Intégrations).
          </p>
        ) : (
          <div className="grid grid-cols-3 gap-px bg-border">
            {state.data.kpis.map((kpi) => (
              <div key={kpi.key} className="bg-card px-3 py-3">
                <p className="text-[10.5px] uppercase tracking-wider text-fabrik-text-3">
                  {kpi.label}
                </p>
                <p className="text-[18px] font-bold text-foreground tabular-nums">
                  {kpi.value.toLocaleString("fr-FR")}
                </p>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
